import { MultiLingualShowcaseData } from './type'

export const multiLingualShowcaseData: MultiLingualShowcaseData = {
  eyebrow: '20+ Languages & Cultures',
  headline: 'Tell it in the language and culture',
  headlineAccent: 'your family calls home.',
  subtitle: 'From bedtime in Tokyo to story hour in São Paulo, every page is written in your mother tongue and woven through with names, foods, settings, and traditions from your culture — so the story feels truly yours, not a translation.',
  sampleTitleLabel: 'Opening line',
  sampleTitle: 'Lily and the Sleepy Star',
  pickerHeading: 'Tap a language to preview',
  ctaText: 'Start your story',
  ctaLink: '/shop',
  footnote: 'New languages and cultural worlds added regularly. Have one you\'d love to see? Let us know.',
  languages: [
    {
      code: 'en',
      nameEnglish: 'English',
      nameNative: 'English',
      flagEmoji: '🇬🇧',
      sampleSentence: 'Once upon a time, a little hero named Lily set off on a great adventure.',
    },
    {
      code: 'es',
      nameEnglish: 'Spanish',
      nameNative: 'Español',
      flagEmoji: '🇪🇸',
      sampleSentence: 'Érase una vez una pequeña heroína llamada Lily que partió en una gran aventura.',
    },
    {
      code: 'fr',
      nameEnglish: 'French',
      nameNative: 'Français',
      flagEmoji: '🇫🇷',
      sampleSentence: 'Il était une fois une petite héroïne appelée Lily qui partit pour une grande aventure.',
    },
    {
      code: 'de',
      nameEnglish: 'German',
      nameNative: 'Deutsch',
      flagEmoji: '🇩🇪',
      sampleSentence: 'Es war einmal eine kleine Heldin namens Lily, die zu einem großen Abenteuer aufbrach.',
    },
    {
      code: 'it',
      nameEnglish: 'Italian',
      nameNative: 'Italiano',
      flagEmoji: '🇮🇹',
      sampleSentence: 'C\'era una volta una piccola eroina di nome Lily che partì per una grande avventura.',
    },
    {
      code: 'pt',
      nameEnglish: 'Portuguese',
      nameNative: 'Português',
      flagEmoji: '🇵🇹',
      sampleSentence: 'Era uma vez uma pequena heroína chamada Lily que partiu para uma grande aventura.',
    },
    {
      code: 'nl',
      nameEnglish: 'Dutch',
      nameNative: 'Nederlands',
      flagEmoji: '🇳🇱',
      sampleSentence: 'Er was eens een kleine heldin, Lily, die op een groot avontuur vertrok.',
    },
    {
      code: 'sv',
      nameEnglish: 'Swedish',
      nameNative: 'Svenska',
      flagEmoji: '🇸🇪',
      sampleSentence: 'Det var en gång en liten hjälte som hette Lily som gav sig ut på ett stort äventyr.',
    },
    {
      code: 'no',
      nameEnglish: 'Norwegian',
      nameNative: 'Norsk',
      flagEmoji: '🇳🇴',
      sampleSentence: 'Det var en gang en liten helt som het Lily, som la ut på et stort eventyr.',
    },
    {
      code: 'da',
      nameEnglish: 'Danish',
      nameNative: 'Dansk',
      flagEmoji: '🇩🇰',
      sampleSentence: 'Der var engang en lille heltinde ved navn Lily, som drog ud på et stort eventyr.',
    },
    {
      code: 'fi',
      nameEnglish: 'Finnish',
      nameNative: 'Suomi',
      flagEmoji: '🇫🇮',
      sampleSentence: 'Olipa kerran pieni sankari nimeltään Lily, joka lähti suureen seikkailuun.',
    },
    {
      code: 'pl',
      nameEnglish: 'Polish',
      nameNative: 'Polski',
      flagEmoji: '🇵🇱',
      sampleSentence: 'Dawno, dawno temu mała bohaterka o imieniu Lily wyruszyła na wielką przygodę.',
    },
    {
      code: 'cs',
      nameEnglish: 'Czech',
      nameNative: 'Čeština',
      flagEmoji: '🇨🇿',
      sampleSentence: 'Bylo nebylo, malá hrdinka jménem Lily se vydala na velké dobrodružství.',
    },
    {
      code: 'hu',
      nameEnglish: 'Hungarian',
      nameNative: 'Magyar',
      flagEmoji: '🇭🇺',
      sampleSentence: 'Egyszer volt, hol nem volt, egy kis hős, Lily, nagy kalandra indult.',
    },
    {
      code: 'ro',
      nameEnglish: 'Romanian',
      nameNative: 'Română',
      flagEmoji: '🇷🇴',
      sampleSentence: 'A fost odată ca niciodată o mică eroină pe nume Lily, care a pornit într-o mare aventură.',
    },
    {
      code: 'el',
      nameEnglish: 'Greek',
      nameNative: 'Ελληνικά',
      flagEmoji: '🇬🇷',
      sampleSentence: 'Μια φορά κι έναν καιρό, μια μικρή ηρωίδα ονόματι Λίλι ξεκίνησε για μια μεγάλη περιπέτεια.',
    },
    {
      code: 'uk',
      nameEnglish: 'Ukrainian',
      nameNative: 'Українська',
      flagEmoji: '🇺🇦',
      sampleSentence: 'Жила-була маленька героїня на ім\'я Лілі, яка вирушила у велику пригоду.',
    },
    {
      code: 'vi',
      nameEnglish: 'Vietnamese',
      nameNative: 'Tiếng Việt',
      flagEmoji: '🇻🇳',
      sampleSentence: 'Ngày xửa ngày xưa, có một tiểu anh hùng tên là Lily, cô bé bước vào một cuộc phiêu lưu lớn.',
    },
    {
      code: 'ja',
      nameEnglish: 'Japanese',
      nameNative: '日本語',
      flagEmoji: '🇯🇵',
      sampleSentence: 'むかしむかし、リリーという小さな英雄が大きな冒険に出かけました。',
    },
    {
      code: 'yue',
      nameEnglish: 'Cantonese',
      nameNative: '廣東話',
      flagEmoji: '🇭🇰',
      sampleSentence: '從前，有個小英雄叫 Lily，佢出發去一場大冒險。',
    },
  ],
}
